import { render, staticRenderFns } from "./TooManyPhotoBookPicturesErrorDialog.vue?vue&type=template&id=6fedc8d2&"
import script from "./TooManyPhotoBookPicturesErrorDialog.vue?vue&type=script&lang=js&"
export * from "./TooManyPhotoBookPicturesErrorDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports